import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KDividerModule } from '../../k-divider/k-divider.module';
import { KPackageCardComponent } from './k-package-card.component';
import { KCardsModule } from '../k-cards.module';



@NgModule({
  declarations: [
    KPackageCardComponent
  ],
  imports: [
    CommonModule,
    KDividerModule,
    KCardsModule
  ],
  exports: [
    KPackageCardComponent
  ]
})
export class KPackageCardModule { }
